import {
  FETCH_CARS,
  FETCH_CARS_SUCCESS,
  FETCH_CARS_FAILED,
  EDIT_CAR
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, update, set, child, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import getCurrentUid from '../other/getCurrentUid';

const getNativeStorage = () => {
  try {
    return require('@react-native-firebase/storage').default;
  } catch (error) {
    return null;
  }
};

const uriToUploadBlob = (uri) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => resolve(xhr.response);
    xhr.onerror = () => reject(new Error("URI_TO_BLOB_FAILED"));
    xhr.responseType = "blob";
    xhr.open("GET", uri, true);
    xhr.send(null);
  });

const uploadCarImageFile = async (webRef, nativePath, fileData) => {
  const nativeStorage = getNativeStorage();
  const contentType = fileData?.mimeType || 'image/jpeg';

  if (nativeStorage && fileData?.uri) {
    const nativeRef = nativeStorage().ref(nativePath);
    await nativeRef.putFile(fileData.uri, {
      contentType,
    });
    return await nativeRef.getDownloadURL();
  }

  if (fileData?.uri) {
    const uploadBlob = await uriToUploadBlob(fileData.uri);
    await uploadBytesResumable(webRef, uploadBlob, { contentType });
    uploadBlob?.close?.();
  } else {
    await uploadBytesResumable(webRef, fileData, { contentType });
    fileData?.close?.();
  }

  return await getDownloadURL(webRef);
};

export const fetchCars = () => (dispatch) => {

  const {
      carsRef
  } = firebase;

  dispatch({
    type: FETCH_CARS,
    payload: null
  });

  const userInfo = store.getState().auth.profile;

  onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i]
      });
      dispatch({
        type: FETCH_CARS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_CARS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_cars
      });
    }
  });
};

export const editCar = (car, method) => async (dispatch) => {
  const {
    singleUserRef,
    carAddRef, 
    carEditRef,
    carImage
  } = firebase;
  dispatch({
    type: EDIT_CAR,
    payload: { method, car }
  });
  if (method === 'Add') {
      push(carAddRef, car);
  } else if (method === 'Delete') {
      remove(carEditRef(car.id));
  } else if (method === 'UpdateImage') {
    let image = await uploadCarImageFile(carImage(car.id), `cars/${car.id}`, car.car_image);
    let data = car;
    data.car_image = image;
    set(carEditRef(car.id), data);
    if(car.active && car.driver){
      update(singleUserRef(car.driver), {
        updateAt: new Date().getTime(),
        car_image: image
      });
    }   
  }
   else {
      set(carEditRef(car.id),car);
  }
}

export const updateUserCarWithImage = (newData, imageFile) => async (dispatch) => {
  const {
    auth,
    carAddRef,
    singleUserRef,
    carImage
  } = firebase;

  var carId = push(carAddRef).key;

  const url = await uploadCarImageFile(carImage(carId), `cars/${carId}`, imageFile);
  newData.car_image = url;
  await set(child(carAddRef, carId), newData);
  if(newData.active){
    let updateData = {
      carType: newData.carType,
      vehicleNumber: newData.vehicleNumber,
      vehicleMake: newData.vehicleMake,
      vehicleModel: newData.vehicleModel,
      other_info: newData.other_info,
      car_image:url,
      carApproved: newData.approved,
      updateAt: new Date().getTime()
    };
    await update(singleUserRef(getCurrentUid(auth)), updateData);
  }
};
